module.exports = __webpack_public_path__ + "static/media/vandan.5a54183a.JPG";